import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import MenuAccountMobile from '../menu/MenuAccountMobile'
import SidebarLeft from './SidebarLeft'

const SidebarAccount = (props) => {
  const [openToggle, setOpenToggle] = useState(true)
  const [openSidebar, setOpenSidebar] = useState(false)
  const sidebarRef = useRef()
  const handleStatusSidebar = () => {
    openToggle ? setOpenToggle(false) : setOpenToggle(true)
    handleToggle(openToggle)
  }
  const handleToggle = (value) => setOpenSidebar(value)

  useEffect(() => {
    const handleCloseOutside = (e) => {
      if (sidebarRef && !sidebarRef.current.contains(e.target)) {
        setOpenSidebar(false)
        setOpenToggle(!openSidebar)
      }
    }
    document.addEventListener('mousedown', handleCloseOutside)

    return () => document.removeEventListener('mousedown', handleCloseOutside)
  }, [openSidebar])
  return (
    <>
      <div>
        <div
          id="sidebarHeaderInvokerMenu"
          type="button"
          className="navbar-toggler d-block btn btn-hamburger u-hamburger mr-3 mr-xl-0 z-index-2"
          data-clicked={openToggle}
          onClick={handleStatusSidebar}
        >
          {props.children}
        </div>
      </div>
      <SidebarLeft menu={openSidebar} setMenuCallback={handleToggle} sidebarRef={sidebarRef}>
        <MenuAccountMobile setMenuCallback={handleToggle} />
      </SidebarLeft>
    </>
  )
}

SidebarAccount.propTypes = {
  children: PropTypes.any,
  content: PropTypes.any,
}

export default SidebarAccount
